export default "<p>hrms works!</p>\n";